import { Filter, type SelectItem } from '@vrplatform/components';
import type { accountType_enum } from '@vrplatform/graphql';
import { formatAccountType } from '@vrplatform/ui-common';
import type { Maybe } from '@vrplatform/utils';
import type { BaseCustomFilterProps } from './_types';

interface Props extends BaseCustomFilterProps {
  type: Maybe<accountType_enum>;
  setType: (type: accountType_enum | null) => void;
}

const TYPE_OPTIONS: SelectItem<accountType_enum>[] = [
  {
    label: formatAccountType('bank'),
    value: 'bank',
  },
  {
    label: formatAccountType('ledger'),
    value: 'ledger',
  },
  {
    label: formatAccountType('recurringFee'),
    value: 'recurringFee',
  },
  {
    label: formatAccountType('nonPosting'),
    value: 'nonPosting',
  },
];

export const AccountTypeFilter = ({ type, setType, label = 'Type' }: Props) => {
  const value = TYPE_OPTIONS.find((option) => option.value === type) ?? null;

  return (
    <Filter.Select
      type="single"
      label={label}
      value={value}
      data={{
        options: TYPE_OPTIONS,
      }}
      setValue={(value) => setType(value?.value || null)}
      hideSearch
    />
  );
};
